export class MathUtils {

  public static anglesDistance(alpha: number, beta: number): number {
    let distance = Math.abs(beta - alpha) % 360;
    return distance > 180 ? 360 - distance : distance;
  }

  public static roundCoordinates(coordinate: number): number {
    return Math.round(coordinate * 1000000) / 1000000;
  }

  public static distanceKm(fromLat: number, fromLng: number, toLat: number, toLng: number): number {
    const earthRadius = 6371;
    const dLat = MathUtils.radians(toLat - fromLat);
    const dLng = MathUtils.radians(toLng - fromLng);
    const haversine = Math.sin(dLat / 2) ** 2
      + Math.cos(MathUtils.radians(fromLat)) * Math.cos(MathUtils.radians(toLat)) * Math.sin(dLng / 2) ** 2;
    return Math.round(2 * earthRadius * Math.asin(Math.sqrt(haversine)));
  }

  public static radians(degrees): number {
    return degrees * Math.PI / 180;
  }

  public static degrees(radians): number {
    return radians * Math.PI / 180;
  }

}
